import { createSlice } from '@reduxjs/toolkit'
import UserThunk from 'administration/components/user/actions/UserThunk'
import AgriThunk from 'agriAdministration/actions/AgriThunk'
import CampaignThunk from 'campaign/actions/CampaignThunk'
import CatchmentThunk from 'catchment/actions/CatchmentThunk'
import DistributionUnitThunk from 'distributionUnit/actions/DistributionUnitThunk'
import HydrometryThunk from 'hydrometry/actions/HydrometryThunk'
import InstallationThunk from 'installation/actions/InstallationThunk'
import MaterielThunk from 'materiel/actions/MaterielThunk'
import PiezometryThunk from 'piezometry/actions/PiezometryThunk'
import PluviometryThunk from 'pluviometry/actions/PluviometryThunk'
import ProductionUnitThunk from 'productionUnit/actions/ProductionUnitThunk'
import QualityThunk from 'quality/actions/QualityThunk'
import ContactThunk from 'referencial/components/contact/actions/ContactThunk'
import ContributorThunk from 'referencial/components/contributor/actions/ContributorThunk'
import { IDLE, LOADING, REJECTED, SUCCEEDED } from './DataManagerConstants'


export const initialState = { // garder la même structure que les reducer
    materiel: {
        settingRulesStatus: IDLE,
    },
    catchment: {
        catchmentsStatus: IDLE,
        catchmentPointsStatus: IDLE,
        catchmentsAnalysisStatus: IDLE,
    },
    user: {
        userBookmarksStatus: IDLE,
    },
    quality: {
        qualitometersListSpecificStatus: IDLE,
    },
    campaign: {
        qualityCampaignsStatus: IDLE,
        qualityCampaignsProgressStatus: IDLE,
        piezometryCampaignsStatus: IDLE,
        piezometryCampaignsProgressStatus: IDLE,
    },
    piezometry: {
        piezometersLightStatus: IDLE,
        piezometryRawSituationStatus: IDLE,
    },
    hydrometry: {
        hydrometricStationsStatus: IDLE,
        hydroStatsStatus: IDLE,
        hydroBookmarksStatsStatus: IDLE,
    },
    productionUnit: {
        productionUnitsStatus: IDLE,
    },
    pluviometry: {
        pluviometersStatus: IDLE,
    },
    agri: {
        exploitationsLightStatus: IDLE,
        surveysWithStatsStatus: IDLE,
    },
    installation: {
        installationsLightStatus: IDLE,
    },
    distributionUnit: {
        distributionUnitsStatus: IDLE,
    },
    contact: {
        contactsStatus: IDLE,
    },
    contributor: {
        contributorsStatus: IDLE,
    },
    perimeters: {
        perimetersFolderStatus: IDLE,
        perimetersStatus: IDLE,
        mortgageStatus: IDLE,
        perimetersFolderPrivateOwnersStatus: IDLE,
        perimetersFolderCompanyOwnersStatus: IDLE,
    },
}

const getThunk = (builder, fetch, reducer, stateName) => {
    builder.addCase(fetch.pending, state => {
        state[reducer][stateName] = LOADING
    })
    builder.addCase(fetch.fulfilled, state => {
        state[reducer][stateName] = SUCCEEDED
    })
    builder.addCase(fetch.rejected, (state, action) => {
        if (!action.meta.condition || state[reducer][stateName] === IDLE) {
            state[reducer][stateName] = REJECTED
        }
    })
}

const store = createSlice({
    name: 'dataManager',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // add reset action here
        builder.addCase('catchment/reset', (state) => {
            state.catchment.catchmentsAnalysisStatus = IDLE
        })
        builder.addCase('hydrometry/resetHydroStats', (state) => {
            state.hydrometry.hydroStatsStatus = IDLE
        })
        builder.addCase('piezometry/resetPiezometryRawSituation', (state) => {
            state.piezometry.piezometryRawSituationStatus = IDLE
        })

        getThunk(builder, MaterielThunk.fetchSettingRules, 'materiel', 'settingRulesStatus')
        getThunk(builder, CatchmentThunk.fetchCatchments, 'catchment', 'catchmentsStatus')
        getThunk(builder, CatchmentThunk.fetchCatchmentPoints, 'catchment', 'catchmentPointsStatus')
        getThunk(builder, CatchmentThunk.fetchCatchmentsAnalysis, 'catchment', 'catchmentsAnalysisStatus')
        getThunk(builder, UserThunk.fetchBookmarks, 'user', 'userBookmarksStatus')
        getThunk(builder, QualityThunk.fetchQualitometersListSpecific, 'quality', 'qualitometersListSpecificStatus')
        getThunk(builder, CampaignThunk.fetchQualityCampaigns, 'campaign', 'qualityCampaignsStatus')
        getThunk(builder, CampaignThunk.fetchQualityCampaignsProgress, 'campaign', 'qualityCampaignsProgressStatus')
        getThunk(builder, PiezometryThunk.fetchPiezometersLight, 'piezometry', 'piezometersLightStatus')
        getThunk(builder, CampaignThunk.fetchPiezometryCampaigns, 'campaign', 'piezometryCampaignsStatus')
        getThunk(builder, CampaignThunk.fetchPiezometryCampaignsProgress, 'campaign', 'piezometryCampaignsProgressStatus')
        getThunk(builder, PiezometryThunk.fetchPiezometryRawSituation, 'piezometry', 'piezometryRawSituationStatus')
        getThunk(builder, HydrometryThunk.fetchHydrometricStations, 'hydrometry', 'hydrometricStationsStatus')
        getThunk(builder, HydrometryThunk.fetchHydroBookmarksStats, 'hydrometry', 'hydroBookmarksStatsStatus')
        getThunk(builder, ProductionUnitThunk.fetchProductionUnits, 'productionUnit', 'productionUnitsStatus')
        getThunk(builder, PluviometryThunk.fetchPluviometers, 'pluviometry', 'pluviometersStatus')
        getThunk(builder, AgriThunk.fetchExploitationsLight, 'agri', 'exploitationsLightStatus')
        getThunk(builder, AgriThunk.fetchSurveysWithStats, 'agri', 'surveysWithStatsStatus')
        getThunk(builder, InstallationThunk.fetchInstallationsLight, 'installation', 'installationsLightStatus')
        getThunk(builder, DistributionUnitThunk.fetchDistributionUnits, 'distributionUnit', 'distributionUnitsStatus')
        getThunk(builder, ContactThunk.fetchContacts, 'contact', 'contactsStatus')
        getThunk(builder, ContributorThunk.fetchContributors, 'contributor', 'contributorsStatus')
    },
})

export default store.reducer